export default "__VITE_ASSET__Cg$J4hRf__"